//Core
import React from "react"

//Styles
import style from "./style.module.scss"
import jump from "jump.js"

const {
  header,
  hero,
  dots,
  textWrapper,
  title,
  subtitle,
  detailsBlock,
  list,
  annotation,
  orderButton,
} = style

const rules = [
  `тимчасове відтермінування платежів за тілом кредиту на період кредитних канікул`,
  `не є зменшенням суми заборгованості за кредитом`,
  `не є відміною платежів за кредитом.`,
]

const HeaderComponents = () => {
  return (
    <header className={header}>
      <div className={dots}></div>
      <div className={hero}></div>

      <div className={textWrapper}>
        <h1 className={title}>Кредитні канікули</h1>
        <h2 className={subtitle}>
          За кредитами готівкою та беззаставними кредитами
        </h2>

        <div className={detailsBlock}>
          <ul className={list}>
            {rules.map((text, key) => (
              <li key={key}>
                <span>{text}</span>
              </li>
            ))}
          </ul>
          <div className={annotation}>
            <span>Важливо! </span>
            Після закінчення Кредитних канікул Ваш платіж буде збільшено на суми
            відтермінованих платежів за тілом кредиту
          </div>
          <div className={orderButton} onClick={() => jump("#form")}>
            ПРИЄДНАТИСЯ ДО КАНІКУЛ
          </div>
        </div>
      </div>
    </header>
  )
}

export default HeaderComponents
